import { tabOutlineListTree } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type { FeatureConfig } from 'src/models'

const featureConfig: FeatureConfig = {
  main: {
    icon: tabOutlineListTree,
    label: 'Group',
    dummy: true
  }
}

export default featureConfig
